<template>
  <a class="" style="cursor: pointer" @click.prevent="copy($el, value, id)">
    <slot></slot>
    <i class="copy-link"></i>
  </a>
</template>

<script lang="ts">

import {defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {useNotification} from "@kyvg/vue3-notification";

export default defineComponent({
  props: {
    value: {
      default: ''
    } as Prop<string|number|any>,
  },
  setup(props) {
    const notification = useNotification()

    const state = reactive({
      id: props.value + Math.random().toString()
    });


    const copy = (el: any, value: string, id: string) => {
      helper.copy(el, value, id)
      notification.notify({title: helper.trans('labels.copied'), text: value});
    }

    return {
      ...toRefs(state),
      copy,
      helper
    }
  }
})
</script>
